import { Link } from "react-router-dom";
import { Clock, MapPin, UserRound } from "lucide-react";
import { tanggal } from "@/lib/format";
import { STATUS, ROLE_LABELS, waktuLabel } from "@/lib/activity";
import { CategoryBanner } from "./CategoryBanner";

export const ActivityCard = ({ a }) => {
  const st = STATUS[a.status] || STATUS.terjadwal;
  const people = Object.entries(a.people || {});
  return (
    <Link to={`/kegiatan/${a.id}`} className="card-hover block rounded-3xl bg-white border border-emerald-900/10 overflow-hidden" data-testid={`activity-card-${a.id}`}>
      <CategoryBanner category={a.category} status={a.status} image={a.banner_path} compact />
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="shrink-0 w-14 rounded-2xl emerald-bg text-white text-center py-2">
            <p className="text-xl font-extrabold leading-none">{tanggal(a.date, "d")}</p>
            <p className="text-[10px] uppercase tracking-wide text-[#d4af37] font-semibold mt-1">{tanggal(a.date, "MMM")}</p>
          </div>
          <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${st.tone}`} data-testid={`activity-card-status-${a.id}`}>{st.label}</span>
        </div>
        <h3 className={`mt-3 font-bold text-emerald-950 leading-snug ${a.status === "dibatalkan" ? "line-through text-slate-400" : ""}`}>{a.title}</h3>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1"><Clock size={12} /> {waktuLabel(a)}</span>
          {a.location && <span className="inline-flex items-center gap-1"><MapPin size={12} /> {a.location}</span>}
        </div>
        {people.length > 0 && (
          <p className="mt-2 text-xs text-emerald-800 inline-flex items-center gap-1">
            <UserRound size={12} /> {people.slice(0, 2).map(([r, p]) => `${ROLE_LABELS[r]}: ${p.name}`).join(" · ")}{people.length > 2 ? " · …" : ""}
          </p>
        )}
      </div>
    </Link>
  );
};
